import React from 'react';
import axios from 'axios';
import { ReqAcEditDeviceInfo } from '../types/ce-api/Devices';
import { ApiUrl } from '../conf/config';

export const useEditDeviceInfo = () => {
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState(false);

  const editDeviceInfo = (device_id: number, device: ReqAcEditDeviceInfo) => {
    setError(false);
    setLoading(true);

    let token:string|null = sessionStorage.getItem('token');
    const config = {
      headers: { Authorization: `Bearer ${token}` }
    };

    axios
      .put(`${ApiUrl}/ac/api/v1/devices/${device_id}`, device,config)
      .then((res) => {
        console.log(res.data);
      })
      .catch((error) => {
        console.error(error);
        setError(true);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return { editDeviceInfo, loading, error };
};
